module.exports = __webpack_public_path__ + "img/vegetable-avocados-190x100.9dfabb88.jpg";